import {
  GET_JOURNAL_DAYS_SUCCESS,
  GET_JOURNAL_DAYS_FAIL,

  GET_JOURNAL_BY_DAY_SUCCESS,
  GET_JOURNAL_BY_DAY_FAIL,

  CREATE_JOURNAL_ENTRY_SUCCESS,
  CREATE_JOURNAL_ENTRY_FAIL,

  UPDATE_JOURNAL_ENTRY_SUCCESS,
  UPDATE_JOURNAL_ENTRY_FAIL,

  DELETE_JOURNAL_ENTRY_SUCCESS,
  DELETE_JOURNAL_ENTRY_FAIL,

  GET_JOURNAL_TIMELINE,
  GET_JOURNAL_TIMELINE_SUCCESS,
  GET_JOURNAL_TIMELINE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  daysWithNotes: [], // ["2026-01-20", ...]
  notes: [],         // notes for the currently viewed day
  timelineNotes: [], // all notes across all days (for timeline view)
  timelineLoading: false,
  error: null,
};

const journal = (state = INIT_STATE, action) => {
  switch (action.type) {
      // -------------------------
      // GET days with notes
      // -------------------------
    case GET_JOURNAL_DAYS_SUCCESS:
      return {
        ...state,
        daysWithNotes: action.payload || [],
        error: null,
      };

    case GET_JOURNAL_DAYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

      // -------------------------
      // GET notes by day
      // -------------------------
    case GET_JOURNAL_BY_DAY_SUCCESS:
      return {
        ...state,
        notes: action.payload || [],
        error: null,
      };

    case GET_JOURNAL_BY_DAY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

      // -------------------------
      // CREATE
      // -------------------------
    case CREATE_JOURNAL_ENTRY_SUCCESS: {
      const created = action.payload;

      const nextNotes = created ? [created, ...state.notes] : state.notes;

      const createdDay = created?.date;
      const nextDays =
          createdDay && !state.daysWithNotes.includes(createdDay)
              ? [...state.daysWithNotes, createdDay].sort()
              : state.daysWithNotes;

      const nextTimeline = created ? [...state.timelineNotes, created] : state.timelineNotes;

      return {
        ...state,
        notes: nextNotes,
        daysWithNotes: nextDays,
        timelineNotes: nextTimeline,
        error: null,
      };
    }

    case CREATE_JOURNAL_ENTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

      // -------------------------
      // UPDATE
      // -------------------------
    case UPDATE_JOURNAL_ENTRY_SUCCESS: {
      const updated = action.payload;
      if (!updated?.note_id) {
        return { ...state, error: null };
      }

      return {
        ...state,
        notes: state.notes.map((n) =>
            n.note_id === updated.note_id ? updated : n
        ),
        error: null,
      };
    }

    case UPDATE_JOURNAL_ENTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

      // -------------------------
      // DELETE
      // -------------------------
    case DELETE_JOURNAL_ENTRY_SUCCESS: {
      const noteId = action.payload;

      return {
        ...state,
        notes: state.notes.filter((n) => n.note_id !== noteId),
        timelineNotes: state.timelineNotes.filter((n) => n.note_id !== noteId),
        error: null,
      };
    }

    case DELETE_JOURNAL_ENTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_JOURNAL_TIMELINE:
      return { ...state, timelineLoading: true, error: null };

    case GET_JOURNAL_TIMELINE_SUCCESS:
      return { ...state, timelineNotes: action.payload || [], timelineLoading: false, error: null };

    case GET_JOURNAL_TIMELINE_FAIL:
      return { ...state, timelineLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default journal;
